package io.eqoty.secretk.utils

import co.touchlab.kermit.Logger

internal val logger = Logger.withTag("secretk")